// Default Q Drives concierge WhatsApp — used as a fallback when no seller/buyer
// phone is provided (e.g. customer-facing "Talk to us" links on the public site).
export const WA_NUMBER = "918977986662";

/**
 * Builds a wa.me link.
 *
 * @param {string} message   Pre-filled message body.
 * @param {string} [phone]   Target phone (digits + optional '+'); falls back
 *                           to the Q Drives concierge number when omitted.
 *
 * Historical note: this function used to ignore the phone arg, so every
 * admin-side "WhatsApp the seller" link silently routed to Q Drives Ops.
 * Always pass the lead's phone explicitly when contacting a seller/buyer.
 */
export function waLink(message = "", phone) {
  const digits = (phone || WA_NUMBER).toString().replace(/\D/g, "");
  const target = digits || WA_NUMBER;
  const base = `https://wa.me/${target}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
